import { makeStyles } from 'tss-react/mui';

export default makeStyles()({
    header: {
        fontWeight: 800,
        fontSize: 36,
        margin: '36px 0 20px',
        display: 'flex',
        wordBreak: 'break-all',
        '@media (max-width: 960px)': {
            fontSize: 33
        }
    },
    added: {
        background: '#E5F6ED'
    },
    removed: {
        background: '#FFEBED'
    }
});
